<section class="page-shell">
  <header class="page-header">
    <h4>Doublons Personne Physique ({{ page()?.totalCount }})</h4>

    <div class="page-header-actions">
      <oui-button
        iconSuffix="download"
        (click)="exportCsv()"
        [disabled]="exporting() || loading()">
        Export CSV
      </oui-button>
      <oui-button
        color="secondary"
        type="outlined"
        iconSuffix="sync"
        (click)="reload()"
        [disabled]="loading()">
        Recharger
      </oui-button>
    </div>
  </header>

  @if (error() && !loading()) {
    <dbw-state-card
      appearance="error"
      title="Chargement impossible">
      <p>{{ error() }}</p>
    </dbw-state-card>
  }

  <section class="content-grid">
    <article class="panel search-panel dbw-card dbw-card--xl">
      <h5>Filtres</h5>
      <div class="filters">
        <div class="filters-group">
          <div class="subtitle-1">Investisseur</div>
          <div class="filters-row">
            <oui-textfield
              label="InvestisseurId"
              type="number"
              [value]="investorIdFilter()"
              (valueChange)="onInvestorIdFilterChange($event ? $event.toString() : '')">
            </oui-textfield>
            <oui-textfield
              label="Code investisseur"
              [value]="investorCodeFilter()"
              (valueChange)="onInvestorCodeFilterChange($event ? $event.toString() : '')">
            </oui-textfield>
            <oui-textfield
              class="search-field-name"
              label="Nom / prénom investisseur"
              [value]="investorNameFilter()"
              (valueChange)="onInvestorNameFilterChange($event ? $event.toString() : '')">
            </oui-textfield>
            <oui-select-filter
              class="search-field-status"
              label="Statuts investisseur"
              type="list"
              listPlaceholder="Rechercher un statut"
              [listOptions]="investorStatusFilterOptions"
              [value]="investorStatusFilter()"
              (valueChange)="onInvestorStatusFilterChange($event ?? [])">
            </oui-select-filter>
            <oui-textfield
              label="PersonnePhysiqueId"
              type="number"
              [value]="primaryFilter()"
              (valueChange)="onPrimaryFilterChange($event ? $event.toString() : '')">
            </oui-textfield>
          </div>
        </div>
        <div class="filters-group">
          <div class="subtitle-1">Consultant</div>
          <div class="filters-row">
            <oui-textfield
              label="ConsultantId"
              type="number"
              [value]="consultantIdFilter()"
              (valueChange)="onConsultantIdFilterChange($event ? $event.toString() : '')">
            </oui-textfield>
            <oui-textfield
              label="Code consultant"
              [value]="consultantCodeFilter()"
              (valueChange)="onConsultantCodeFilterChange($event ? $event.toString() : '')">
            </oui-textfield>
            <oui-textfield
              class="search-field-name"
              label="Nom / prénom consultant"
              [value]="consultantNameFilter()"
              (valueChange)="onConsultantNameFilterChange($event ? $event.toString() : '')">
            </oui-textfield>
          </div>
        </div>
      </div>
    </article>

    <article class="panel dbw-card dbw-card--xl">
      <div class="panel-heading">
        <div>
          <h4>Investisseurs à corriger</h4>
          <p>{{ page()?.totalCount ?? 0 }} investisseur(s) correspondant au filtre.</p>
        </div>
      </div>

      @if (!loading() && !error() && (page()?.items?.length ?? 0) === 0) {
        <div class="empty-state">Aucun investisseur ne correspond au filtre courant.</div>
      }

      @if (loading()) {
        <dbw-state-card
          appearance="loading"
          [compact]="true">
          <p>Chargement des doublons de personnes physiques en cours.</p>
        </dbw-state-card>
      }

      @if (!loading() && (page()?.items?.length ?? 0) > 0) {
        <div class="table-shell">
          <oui-table
            class="data-table"
            [lineSizing]="'dense'">
            <table
              mat-table
              [dataSource]="page()?.items ?? []">
              <ng-container matColumnDef="investors">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  Investisseur
                </th>
                <td
                  mat-cell
                  *matCellDef="let row">
                  <dbw-investor-card
                    [id]="row.investorId"
                    [code]="row.investorCode || 'Code inconnu'"
                    [name]="row.displayName || 'Investisseur #' + row.investorId"
                    [statusCode]="row.statusCode"></dbw-investor-card>
                </td>
              </ng-container>

              <ng-container matColumnDef="personnePhysiqueIds">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  Personnes physiques
                </th>
                <td
                  mat-cell
                  *matCellDef="let row">
                  <div class="content-short">
                    <div>{{ formatPersonnePhysiqueIds(row.personnePhysiqueIds) }}</div>
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="consultants">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  Consultant
                </th>
                <td
                  mat-cell
                  *matCellDef="let row">
                  <dbw-consultant-card
                    [id]="row.consultantId"
                    [code]="row.consultantCode || '-'"
                    [name]="row.consultantName || '-'"
                    [statusCode]="row.consultantStatusCode"></dbw-consultant-card>
                </td>
              </ng-container>

              <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          </oui-table>

          <mat-paginator
            [length]="page()?.totalCount ?? 0"
            [pageIndex]="page()?.pageIndex ?? pageIndex()"
            [pageSize]="page()?.pageSize ?? pageSize()"
            [pageSizeOptions]="pageSizeOptions"
            [showFirstLastButtons]="true"
            (page)="onPageChange($event)">
          </mat-paginator>
        </div>
      }
    </article>
  </section>
</section>
